<shared-wizzard-wrapper [type]="type" [topPadding]="true">
    <ng-container *ngFor="let menuFlowPage of combinedMenuFlowPages$ | async;trackBy: trackBy">
        <div class="wizzard__menu-flow-page" directive-menu-flow-page [pageIdentifier]="menuFlowPage.PageIdentifier">

            <shared-wizzard-header>{{menuFlowPage.PageName}}</shared-wizzard-header>

            <shared-list-for-wizzard-products class="wizzard__products-list" [menuFlowPage]="menuFlowPage"
                [menuFlowProducts]="menuFlowPage.Products"></shared-list-for-wizzard-products>

        </div>
    </ng-container>

    <shared-wizzard-special-instructions *ngIf="(showSpecialInstructions$ | async)" [type]="type"
        [isExpanded]="hasSpecialInstructions$ | async">
    </shared-wizzard-special-instructions>
    <shared-disclaimer class="wizzard-for-combined-pages-menu-flow__disclaimer" *ngIf="showDisclaimer">
    </shared-disclaimer>
    <shared-wizzard-quantity [mobile]="quantityMobile" [desktop]="quantityDesktop" [type]="type">
    </shared-wizzard-quantity>

</shared-wizzard-wrapper>